import { render, staticRenderFns } from "./step1Upload.vue?vue&type=template&id=19a389a9&scoped=true&"
import script from "./step1Upload.vue?vue&type=script&lang=js&"
export * from "./step1Upload.vue?vue&type=script&lang=js&"
import style0 from "./step1Upload.vue?vue&type=style&index=0&id=19a389a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a389a9",
  null
  
)

export default component.exports